/* eslint-disable */
import { useCallback } from "react";
import { isEqual } from "lodash";
import { useCalendarValue } from "./useCalendarValue";
import { useCalendarMultiple } from "./useCalendarMultiple";
import { ICalendarSelectorGroup, CalendarMultipleValueType } from "../types";

export function useSelectToggle(
  groups: ICalendarSelectorGroup[],
  updateGroups: (groups: ICalendarSelectorGroup[]) => void,
) {
  return useCallback((value: string | string[]) => {
      const result: ICalendarSelectorGroup[] = [...groups];
      for (const group of groups) {
        for (const item of group.items) {
          item.active = false;
          if (!item.disabled && !item.virtual && value.includes(item.item.id)) {
            item.active = true;
          }
        }
      }
      updateGroups(result);
    },
    [groups],
  );
}
